// extracted by mini-css-extract-plugin
export var dividerContainer = "_7v-0";
export var line = "_7v-1";